import { styled } from '@mui/material';
import { up } from '../../../theme';

export const classes = {
  root: 'root',
  sidebarMainBox: 'sidebarMainBox',
  sidebarToggleButton: 'sidebarToggleButton',
  listMainBox: 'listMainBox',
  listItems: 'listItems',
  listSubItems: 'listSubItems',
  listItemIcons: 'listItemIcons',
  icons: 'icons',
  listItemTexts: 'listItemTexts',
  listSubItemTexts: 'listSubItemTexts',
  listItemExpandIcon: 'listItemExpandIcon',
  listItemExpandIconOpen: 'listItemExpandIconOpen',
  listItemExpandIconClose: 'listItemExpandIconClose',
};

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {},
  [`& .${classes.sidebarMainBox}`]: {
    zIndex: 5,
    [up('xs')]: {
      height: `calc(100vh - ${theme.spacing(6)});`,
    },
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: 0,
    },
    backgroundColor: theme.palette.darkPurple.main,
    transition: 'width 0.5s ease , background-color 0.5s ease',
  },
  [`& .${classes.sidebarToggleButton}`]: {
    color: theme.palette.darkPurple.main,
    '&:hover': {
      color: theme.palette.primary.main,
    },
    margin: '10px 0',
    border: `1px solid ${theme.palette.secondaryBlack.medium}`,
    height: '30px',
    width: '30px',
    minWidth: '0',
    padding: '0 10px',
    transition: 'all 0.4s ease 0s',
  },
  [`& .${classes.listMainBox}`]: {
    padding: '10px 20px',
    height: `calc(100vh - ${theme.spacing(6)});`,
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: 0,
    },
  },
  [`& .${classes.listItems}`]: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: '5px',
    cursor: 'pointer',
    [up('xs')]: {
      padding: '4px 8px',
      marginBottom: '4px',
    },
  },
  [`& .${classes.listSubItems}`]: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: '5px',
    cursor: 'pointer',
    [up('xs')]: {
      padding: '4px 0 4px 44px',
      marginBottom: '4px',
      // margin: '0 0 4px 24px',
      width: 'auto',
    },
  },
  [`& .${classes.listItemIcons}`]: {},
  [`& .${classes.icons}`]: {
    fill: 'none',
    marginRight: '16px',
    [up('xs')]: {
      width: '18px',
      height: '18px',
    },
    [up('md')]: {
      width: '22px',
      height: '22px',
    },
    [up('lg')]: {
      width: '24px',
      height: '24px',
    },
    [up('xl')]: {
      width: '26px',
      height: '26px',
    },
    [up('xxl')]: {
      width: '28px',
      height: '28px',
    },
  },
  [`& .${classes.listItemTexts}`]: {
    '& .MuiTypography-root': {
      textWrap: 'no-wrap',
      fontFamily: 'Heebo',
      fontWeight: '500',
      [up('xs')]: {
        fontSize: '12px',
      },
      [up('sm')]: {
        fontSize: '12px',
      },
      [up('md')]: {
        fontSize: '14px',
      },
      [up('lg')]: {
        fontSize: '16px',
      },
    },
  },
  [`& .${classes.listSubItemTexts}`]: {
    paddingLeft: '1vw',
    '& .MuiTypography-root': {
      fontFamily: 'Heebo',
      fontWeight: '500',
      [up('xs')]: {
        fontSize: '10px',
      },
      [up('sm')]: {
        fontSize: '10px',
      },
      [up('md')]: {
        fontSize: '12px',
      },
      [up('lg')]: {
        fontSize: '14px',
      },
    },
  },
  [`& .${classes.listItemExpandIcon}`]: {
    width: '20px',
    height: '20px',
  },
  [`& .${classes.listItemExpandIconOpen}`]: {
    transition: 'transform 0.4s ease',
    transform: 'rotate(0deg)',
  },
  [`& .${classes.listItemExpandIconClose}`]: {
    transition: 'transform 0.4s ease',
    transform: 'rotate(180deg)',
  },
}));
